import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginforget, authError } from "../../../Reducers/auth/actions";
import { message } from "../../../Reducers/loading/actions";
import { Link, useNavigate } from "react-router-dom";

function ForgetPage() {
  const [email, setEmail] = useState("");
  const errorMessage = useSelector((state) => state.auth.error);
  const signupmsg = useSelector((state) => state.auth.signupmsg);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(authError(null));
  }, [dispatch]);

  useEffect(() => {
    if (errorMessage) {
      dispatch(message(5000, "danger", errorMessage));
    }
    if (signupmsg) {
      dispatch(message(5000, "success", signupmsg));
    }
  }, [errorMessage, signupmsg, dispatch]);

  const userForget = async (e) => {
    e.preventDefault();
    const success = await dispatch(loginforget({ email }));
    if (success === true) {
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    }
  };

  return (
    <div className="login-box-body">
      <p className="login-box-msg">Wachtwoord vergeten</p>
      <form onSubmit={userForget}>
        <div className="row-fluid">
          <div className="form-group has-feedback col-xs-12">
            <input
              value={email}
              onChange={(e) => {
                dispatch(authError(null));
                setEmail(e.target.value);
              }}
              name="email"
              type="email"
              className="form-control"
              placeholder="Email"
            />
            <span className="glyphicon glyphicon-envelope form-control-feedback" />
          </div>
          <div className="form-group has-feedback row">
            <div className="col-xs-8"></div>
            <div className="col-xs-4">
              <button type="submit" className="loginbutton btn btn-primary btn-block btn-flat">
                Wachtwoord opvragen
              </button>
            </div>
          </div>
          <div className="span12">
            <Link to="/login" className="text-center">
              Terug
            </Link>
          </div>
        </div>
      </form>
    </div>
  );
}

export default ForgetPage;
